import { crudMdActions } from "@/services/crud-md-actions";

const name = "mailing-templates";

export default {
  name,
  ...crudMdActions(name),
};
